import type { FunctionComponent } from 'react'

import { platformService } from '@monthio/react-components'
import i18next from 'i18next'
import styled from 'styled-components'

const Pre = styled.pre`
	height: 100%;
`
// Show value for generic landing page
// Show config in flow
export const FlowContext: FunctionComponent<{ children?: never }> = () => {
	return (
		<Pre>
			Namespace: {platformService.getNamespace()}
			<br />
			Environment: {platformService.getEnvironment()}
			<br />
			<button onClick={changeLanguage}>
				{i18next.language === 'cimode'
					? 'Show translations'
					: 'Show translation keys'}
			</button>
		</Pre>
	)
}

const changeLanguage = () => {
	const lng = i18next.language
	if (lng !== 'cimode') {
		appendLngToSearch('cimode')
		return
	}
	appendLngToSearch('en-gb')
}

const appendLngToSearch = (lng: string) => {
	if (location.search) {
		location.search = `${location.search}&lng=${lng}`
		return
	}
	location.search = `?lng=${lng}`
}
